/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState } from "react";
import classnames from "classnames";
import NumberFormat from "react-number-format"
import Skeleton from 'react-loading-skeleton';
import axiosInstance from "./../../helpers/axiosInstance"
import Pdf from "react-to-pdf";
import Icon_pagosInternos from "assets/img/icons/Icono-Pago-Interno-Gris.png"
import Icon_pagosInternosA from "assets/img/icons/Icono-Pago-Interno-Verde.png"
import Icon_pagosRealizados from "assets/img/icons/Icono-Pagos-Realizados-Gris.png"
import Icon_pagosRealizadosA from "assets/img/icons/Icono-Pagos-Realizados-Verde.png"

// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  FormGroup,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Modal
} from "reactstrap";
import { normalizeUnits } from "moment";
import {useDispatch} from "react-redux";
import {cambiaruta,cambiasidebar,desactivasidebar} from "../../Slicersreducers";


function PaysHeader() {

  const [tabToGo, setTabToGo] = useState(0);

  const listStep = [{ title: "Credito" }, { title: "Valor" }, { title: "Desde" }, { title: "Confirma" }];
  const listStepPse = [{ title: "Credito" }, { title: "Valor" }, { title: "PSE" }];

  const [tabs, setTabs] = useState(0);

  const [cancelationModal, setCancelationModal] = useState(false);
  const [notificationModal, setNotificationModal] = useState(false);
  const [processModal, setProcessModal] = useState(false);
  const [errorModal, setErrorModal] = useState(false);

  const [step, setStep] = useState(0);
  const [stepPse, setStepPse] = useState(0);

  const [productOne, setProductOne] = useState({});
  const [productTwo, setProductTwo] = useState({});
  const [value, setValue] = useState("");
  const [commission, setCommission] = useState(0);
  const [accounts, setAccounts] = useState([]);
  const [loans, setLoans] = useState([]);
  const [banks, setBanks] = useState([]);
  const [historicalTransfer, setHistoricalTransfer] = useState([]);

  const [isLoadingHistorical, setIsLoadingHistorical] = useState(true);
  const [imagen,setImagen] = useState(Icon_pagosInternos);
  const [color,setColor] = useState("text-gray-dark");
  const [imagenPagosRealizados,setImagenPagosRealizados] = useState(Icon_pagosRealizados);
  const [colorPagosRealizados,setColorPagosRealizados] = useState("text-gray-dark");
  const dispatch=useDispatch();
  var createReactClass = require('create-react-class');
  const ref = React.createRef();

  useEffect(() => {
    dispatch(cambiaruta("Inicio/pagos"));
    dispatch(cambiasidebar(false));
    dispatch(desactivasidebar());
  }, [])

  var CardLoan = createReactClass({
    render: function () {
      var accountNumber = this.props.data.accountNumber,
        balance = this.props.data.balance,
        description = this.props.data.description;
      return (
        <Col lg="12" xl="12" className="pt-3">
          <Card className="mb-xl-0 shadow cursor-pointer">
            <CardBody className="">
              <Row>
                <div className="col-auto ml-4">
                  <Row>
                    <span class="mb-0">{description} No. {accountNumber}</span>
                  </Row>
                  <Row>
                    <span class="mb-0 text-sm">Deuda <NumberFormat value={balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                  </Row>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    }
  });

  async function getLoan(product, tab) {
    await setProductTwo(product);
    if (tab === 1) {
      await setStep(s => s + 1);
    } else if (tab === 2) {
      await setStepPse(s => s + 1);
    }
    await setTabs(tab);
  }

  async function goBack(tab, isFirst) {
    if (!isFirst) {
      if (tab === 1) {
        await setStep(s => s - 1);
      } else if (tab === 2) {
        await setStepPse(s => s - 1);
      }
    } else {
      setCancelationModal(true);
      await setTabToGo(0);
    }
  }


  var Loans = createReactClass({
    render: function () {
      var data = this.props.data;
      var tab = this.props.tab;
      var newsTemplate;

      if ((data.length > 0)) {
        newsTemplate = data.map(function (item, index) {
          return (
            <Row key={index} onClick={() => getLoan(item, tab)}>
              <CardLoan data={item} />
            </Row>
          )
        })
      } else {
        newsTemplate = <Skeleton height={100} count={4} className="card-transaction-info" style={{ width: "-webkit-fill-available" }}></Skeleton>
      }
      return (
        <div>
          {newsTemplate}
        </div>
      );
    }
  });

  var CardAccount = createReactClass({
    render: function () {
      var accountNumber = this.props.data.accountNumber,
        balance = this.props.data.balance,
        description = this.props.data.description,
        accountTypeDescription = (this.props.data.accountType === 3 || this.props.data.accountType === 7) ? 'Deuda' : 'Disponible';
      return (
        <Col lg="12" xl="12" className="pt-3">
          <Card className="mb-xl-0 shadow cursor-pointer">
            <CardBody className="">
              <Row>
                <div className="col-auto ml-4">
                  <Row>
                    <span class="mb-0">{description} No. {accountNumber}</span>
                  </Row>
                  <Row>
                    <span class="mb-0 text-sm"> {accountTypeDescription}  <NumberFormat value={balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                  </Row>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    }
  });

  async function getAccount(product, tab) {
    getCommission(4);
    await setProductOne(product);
    if (tab === 1) {
      await setStep(s => s + 1);
    } else if (tab === 2) {
      await setStepPse(s => s + 1);
    }
    await setTabs(tab);
  }

  async function getCommission(idCommission) {
    let request = {
      operation_type: 1,
      amount: value
    }
    const response = await axiosInstance().get("/WSGYG39_2/api/Inquiries/comissions/" + idCommission + "/" + parseFloat(value.replace(/,/g, '')) + "/" + productOne.accountNumber + "/" + productOne.system )
      .catch(err => {
        return 'err';
      });
    if (response != 'err') {
      setCommission(response.data.cost)
    }
  }

  var Accounts = createReactClass({
    render: function () {
      var data = this.props.data;
      var tab = this.props.tab;
      var newsTemplate;

      if ((data.length > 0)) {
        newsTemplate = data.map(function (item, index) {
          return (
            <Row key={index} onClick={() => getAccount(item, tab)}>
              <CardAccount data={item} />
            </Row>
          )
        })
      } else {
        newsTemplate = <Skeleton height={100} count={4} className="card-transaction-info" style={{ width: "-webkit-fill-available" }}></Skeleton>
      }
      return (
        <div>
          {newsTemplate}
        </div>
      );
    }
  });

  var HistoricalTransfers = createReactClass({
    render: function () {
      var data = this.props.data;
      var newsTemplate;

      if (data.length > 0) {
        newsTemplate = data.map(function (item, index) {
          return (
            <CardHistoricalTransfer key={index}  data={item} />
          )
        }) 
      } else if (isLoadingHistorical) {
        newsTemplate = <Skeleton height={150} count={3} className="card-transaction-info" style={{ width: "-webkit-fill-available" }}></Skeleton>
      } else {
        newsTemplate = <div className="text-center m-4">
          <h2 class="ml-2"> No se encuentran transacciones en el historial. </h2>
        </div>;
      }
      return (
        <div className="col-md-12 p-2" style={{ justifyContent: "space-between" }}>
          {newsTemplate}
        </div>
      );
    }
  });

  var CardHistoricalTransfer = createReactClass({
    render: function () {
      var nut = this.props.data.nut,
      product_Number = this.props.data.product_Number,
      transaction_Value = this.props.data.transaction_Value,
      transaction_Status = this.props.data.transaction_Status,
      date_Transaction = this.props.data.date_Transaction,
      year = this.props.data.date_Transaction.substring(0,3),
      month = this.props.data.date_Transaction.substring(5,6),
      day = this.props.data.date_Transaction.substring(8,9);
      return (
        <div className="shadow" style={{ padding: "10px 15px 0", marginBottom: 16 + 'px', display: "flex", justifyContent: "space-between", flexDirection: "column", position: "relative", padding: 15 + 'px', minHeight: 80 + 'px', borderRadius: 15 + 'px', boxShadow: "0 2px 4px 0 rgb(65 74 83 / 30%)", backgroundColor: "#fff", width: 100 + '%' }}>
          <div style={{ position: "absolute", width: 16 + 'px', height: 16 + 'px', left: 10 + 'px', top: 16 + 'px' }}>
            <i class="fas fa-exchange-alt"></i>
          </div>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
            <p class="mb-2 ml-4" style={{ fontSize: 12 + 'px' }}><span style={{ fontSize: 12 + 'px', fontWeight: 400, color: "#77899a" }}> {date_Transaction} </span> - Pago a préstamo IDEA </p>
            <p class="mb-2 ml-4" style={{ fontSize: 12 + 'px', fontWeight: 400, }}> Ahorros No. {product_Number} </p>
            <p class="mb-2 ml-4" style={{ fontSize: 12 + 'px', fontWeight: 400, }}> Numero de Transacción {nut} </p>
            <p class="mb-2 ml-4" style={{ fontSize: 1 + 'rem', fontWeight: 700, }}> <NumberFormat value={transaction_Value} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </p>
          </div>
        </div>
      );
    }
  });

  function DivStep({ children }) {
    return <>{children}</>
  }

  function Progress(props) {
    const styleProgress = { width: ((100/props.list.length)-2) + '%' };
    var newsTemplate = props.list.map(function (item, index) {
      if (index === props.current) {
        return <div key={index} className="progress-bar-step-active" style={styleProgress}>
          <span className="stepper-number-active">
            <span className="stepper-label-active">{index + 1}</span>
          </span>
        </div>;
      } else {
        return <div key={index} className="progress-bar-step" style={styleProgress}>
          <span className="stepper-number">
            <span className="stepper-label">{index + 1}</span>
          </span>
        </div>;
      }
    });
    return newsTemplate;
  }

  function LineStepper(props) {
    return (
      <>
        <div style={{ position: "relative"}} className="mt-1 m-4 mb-6">
          <div style={{ position: "absolute", width: '100%'}}>
            <Progress
              current={props.current}
              list={props.listStep}
            ></Progress>
            </div>
        </div>
      </>
    );
  }

  function NavigationButtons(props) {
    var isFirst = props.step === 0;
    return (
      <div style={{ justifyContent: "space-between", display: "flex" }}>
        <button class="btn-icon text-gray-dark btn" onClick={() => goBack(props.tab, isFirst)}>
          <span class="btn-inner--icon">
            <i class="fas fa-arrow-left"></i>
          </span>
          <span class="btn-inner--text">Volver</span>
        </button>
        <button class="btn-icon text-gray-dark btn" disabled={isFirst} onClick={() => setCancelationModal(true)}>
          <span class="btn-inner--text">Cancelar</span>
          <span class="btn-inner--icon">
            <i class="fas fa-times"></i>
          </span>
        </button>
      </div>
    );
  };

  function DivStepper({ children, ...props }) {
    const childrenArray = React.Children.toArray(children);

    const currentChild = childrenArray[props.step];
    return (
      <div {...props}>
        <NavigationButtons tab={props.tab} step={props.step}></NavigationButtons>
        <LineStepper current={props.step} listStep={props.listStep}></LineStepper>
        {currentChild}
      </div>
    );
  };

  const valueChange = event => {
    event.preventDefault();
    let val = event.target.value;
    setValue(val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ","));
  }

  async function getRelatedAccounts() {
    await setStep(s => s + 1);
    const request = await axiosInstance().get("/WSGYG39_2/api/Inquiries/Products/Accounts")
      .catch(err => {
        return 'err';
      });
    if (request != 'err') {
      console.log(request.data);
      setAccounts(request.data.summaryProduct.product);
    }
    return request;
  }

  async function getHistoricalTransfer() {
    setIsLoadingHistorical(true);
    const request = await axiosInstance().get("/WSGYG39_2/api/Inquiries/Transactions/Payments")
      .catch(err => {
        setIsLoadingHistorical(false);
        return 'err';
      });
    if (request != 'err') {
      setIsLoadingHistorical(false);
      console.log(request.data);
      setHistoricalTransfer(request.data);
    }
    return request;
  }

  async function getPseBanks() {
    await setStepPse(s => s + 1);
    const request = await axiosInstance().get("/WSGYG39_2/api/Consultas/Bancos")
      .catch(err => {
        return 'err';
      });
    if (request != 'err') {
      console.log(request.data);
      setBanks(request.data.banks)
    }
    return request;
  }

  function PseBanks(props) {
    return (
      <InputGroup className="input-group-alternative mb-4">
        <InputGroupAddon addonType="prepend">
          <InputGroupText>
            <i className="fas fa-university" />
          </InputGroupText>
        </InputGroupAddon>
        <select class="selectpicker" placeholder="Tipo de Docuemnto" className="form-control input-group-alternative">
          {banks.map(function (item, index) {
            return (
              <option key={index} value={item.pseCode}>{item.description}</option>
            )
          })}
        </select>
      </InputGroup>
    );
  }


  useEffect(() => {
    async function getProducts() {
      const request = await axiosInstance().get("/WSGYG39_2/api/Inquiries/Products/Loans")
        .catch(err => {
          return 'err';
        });
      if (request != 'err') {
        console.log(request.data);
        console.log(request.data.summaryProduct.product);
        setLoans(request.data.summaryProduct.product);
      }
      return request;
    }
    getProducts();
  }, []);

  const ejecutasalir=()=>{
    setCancelationModal(false);
  }

  const Pay = async event => {
    setNotificationModal(false);
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    today = yyyy + '' + mm + '' + dd;

    const consulta = {
      AccountNumber: productOne.accountNumber,
      Parameters: [
        productOne.accountNumber,
        productOne.system,
        productTwo.accountNumber,
        productTwo.system,
        (productTwo.sequence === undefined) ? "" : productTwo.sequence,
        "NN090D",
        productOne.accountNumber,
        productTwo.accountNumber,
        today,
        "" + parseFloat(value.replace(/,/g, '')) * 100
      ]
    }
    console.log(consulta);

    const request = await axiosInstance().post("/WSGYG39_2/api/transaction/Transfer/Payments", consulta)
      .catch(err => {
        return 'err';
      });
    if (request != 'err') {
      setProcessModal(true);
      setTabs(0);
      setStep(0);
      setStepPse(0);
    } else {
      setErrorModal(true);
      setTabs(0);
      setStep(0);
      setStepPse(0);
    }
  }

  class NavsTransfer extends React.Component {

    toggleModal = state => {
      setNotificationModal(!notificationModal);
    };
    toggleNavs = (e, state, index) => {
      e.preventDefault();
      if (index == 1) {
        setImagen(Icon_pagosInternosA);
        setColor("text-success")
        setImagenPagosRealizados(Icon_pagosRealizados)
        setColorPagosRealizados("text-gray-dark")
      }else if(index == 3){
        setImagen(Icon_pagosInternos);
        setColor("text-gray-dark")
        setImagenPagosRealizados(Icon_pagosRealizadosA)
        setColorPagosRealizados("text-success")
        
      }else{
        setImagen(Icon_pagosInternos);
        setColor("text-gray-dark")
        setImagenPagosRealizados(Icon_pagosRealizados)
        setColorPagosRealizados("text-gray-dark")
      }

      setTabs(index);
    };
    render() {
      return (
        <>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={cancelationModal}
            toggle={() => setCancelationModal(!cancelationModal)}
          >
            <div className="p-4">
            <div onClick={ejecutasalir} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                            }/>
                                            </span></h1>
                                </div>
              <div class="my-modal-header">
                <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/Cancel.png").default} />
                <div class="header-title">
                  <h5 class="avv-title-bold">¿Quieres salir de la transacción?</h5>
                  <p class="header-subtitle">La información que has ingresado hasta el momento se borrará.</p>
                </div>
              </div>
              <div class="my-modal-footer pt-2">
                <button class="btn bg-white text-green shadow" type="button" onClick={() => setCancelationModal(false)}> No, volver </button>
                <button class="my-btn btn bg-green text-white shadow" type="button" onClick={() => { setTabs(tabToGo); setCancelationModal(false); setStep(0); setStepPse(0); setTabToGo(0) }}> SÍ, SALIR </button>
              </div>
            </div>
          </Modal>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={errorModal}
            toggle={() => setErrorModal(!errorModal)}
          >
            <div className="p-4">
              <div class="my-modal-header">
                <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/error-transaction.svg").default} />
                <div class="header-title">
                  <h5 class="avv-title-bold">La transacción no se pudo realizar</h5>
                  <p class="header-subtitle">Por algun motivo la transacción no se pudo realizar intentelo mas tarde.</p>
                </div>
              </div>
            </div>
          </Modal>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={notificationModal}
            toggle={() => this.toggleModal("notificationModal")}
          >
            <div className="modal-header">
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("notificationModal")}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="py-3 text-center">
                <i className="fas fa-lock ni-3x" />
                <h4 className="heading mt-4">Verifica el pago con el número que se envió a tu celular.</h4>
                <form role="form" class="">
                  <div class="code-group">
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} />
                  </div>
                  <div class="text-center">
                    <button onClick={() => Pay()} color="white" block size="lg" className="my-btn btn bg-gradient-primary text-white shadow btn-block btn-lg">
                      Verificar Pago
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </Modal>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={processModal}
            toggle={() => setProcessModal(!processModal)}
          >
            <div className="p-4">
              <div class="my-modal-header" ref={ref}>
                <img alt="delete-icon" class="my-header-brand-img" src={require("../../assets/img/brand/santander.png").default} />
                <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/success-transfer.svg").default} />
                <div class="header-title">
                  <h5 class="avv-title-bold">Tu Pago al préstamo {productTwo.numeroCuenta} {productTwo.accountNumber} fue aprobada.</h5>
                  <ul className style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Valor</p>
                      <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={value} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                    </li>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Costo</p>
                      <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={commission} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                    </li>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Hacia</p>
                      <div style={{ textAlign: "right", margin: 0 }}>
                        <p style={{ margin: 0 }}>{productTwo.ownerAccount}</p>
                        <p style={{ margin: 0 }}>Santander</p>
                        <p style={{ margin: 0 }}> Préstamo No. {productTwo.accountNumber}</p>
                      </div>
                    </li>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Desde</p>
                      <div style={{ textAlign: "right", margin: 0 }}>
                        <p style={{ margin: 0 }}>Ahorros No. {productOne.accountNumber}</p>
                        <p style={{ margin: 0 }}>Disponible <NumberFormat value={productOne.balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="m-2">
                <button class="my-btn btn bg-gradient-primary text-white shadow btn-block" type="button" onClick={() => { setProcessModal(false); setTabs(0) }}> Continuar </button>
                <Pdf targetRef={ref} filename="comprobante.pdf">
                  {({ toPdf }) => (
                    <button class="btn bg-gradient-white text-gray shadow btn-block btn-icon" type="button" onClick={toPdf}>
                      <span class="btn-inner--icon">
                        <i class="fas fa-download"></i>
                      </span>
                      <span class="btn-inner--text">Descargar comprobante</span>
                    </button>
                  )}
                </Pdf>

              </div>
            </div>
          </Modal>
          <div className="header pb-4 pt-5 pt-md-8">
            <Container fluid>
              <div className="header-body">
                <Nav
                  className="justify-content-center flex-column flex-md-row"
                  id="tabs-icons-text"
                  pills
                  role="tablist"
                >
                  <NavItem>
                    <NavLink
                      aria-selected={tabs === 1}
                      className={classnames("card-body ml-2 mb-2 mb-xl-0 shadow", {
                        active: tabs === 1
                      })}
                      onClick={e => { if (step > 0 || stepPse > 0) { setTabToGo(1); setCancelationModal(true); } else { this.toggleNavs(e, "tabs", 1); }; }}
                      href="#pay"
                      role="tab"
                    >
                      <Row className="justify-content-center m-2">
                        <div className="icon icon-shape">
                          <img className="my-header-image mt-3" src={imagen} />
                        </div>
                      </Row>
                      <Row className={classnames ("justify-content-center mt-0 pb-0",
                            color
                          )}>
                        <p className="mt-0 mb-0 pt-0 text-bold" style={{ fontSize: 14 + 'px', width: 105 + 'px', textAlign: "center", lineHeight: 1.25 +'em', marginTop:2 +'px' }}>
                          Pagos Internos
                        </p>
                      </Row>
                    </NavLink>
                  </NavItem>
                  {/*<NavItem>
                      <NavLink
                      aria-selected={tabs === 2}
                      className={classnames("card-body ml-2 mb-2 mb-xl-0 shadow", {
                        active: tabs === 2
                      })}
                      onClick={e => { if (step > 0 || stepPse > 0) { setTabToGo(2); setCancelationModal(true); } else { this.toggleNavs(e, "tabs", 2); }; }}
                      href="#pse"
                      role="tab"
                    >
                      <Row className="justify-content-center m-2">
                        <div className="icon icon-shape">
                          <img className="my-header-image mt-5" src={require("../../assets/img/illustrations/select-loan-pse.svg").default} />
                        </div>
                      </Row>
                      <Row className="justify-content-center m-2">
                        <p className="mt-3 mb-0 text-bold text-primary" style={{ fontSize: 13 + 'px', width: 101 + 'px', textAlign: "center", lineHeight: 1.43 }}>
                          Pago pse
                        </p>
                      </Row>
                    </NavLink>
                  </NavItem>*/}
                  <NavItem>
                    <NavLink
                      aria-selected={tabs === 3}
                      className={classnames("card-body ml-2 mb-2 mb-xl-0 shadow", {
                        active: tabs === 3
                      })}
                      onClick={e => { if (step > 0 || stepPse > 0) { setTabToGo(3); setCancelationModal(true); getHistoricalTransfer(); } else { this.toggleNavs(e, "tabs", 3); getHistoricalTransfer(); }; }}
                      href="#history"
                      role="tab"
                    >
                      <Row className="justify-content-center m-0">
                        <div className="icon icon-shape">
                          <img className="my-header-image mt-3" src={imagenPagosRealizados} />
                        </div>
                      </Row>
                      <Row className={classnames ("justify-content-center mt-0 pb-0",
                            colorPagosRealizados
                          )}>
                        <p className="mt-0 mb-0 pt-0 text-bold" style={{ fontSize: 14 + 'px', width: 105 + 'px', textAlign: "center", lineHeight: 1.25 +'em', marginTop:2 +'px' }}>
                          Pagos realizados
                        </p>
                      </Row>
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </Container>
          </div>
          <Container >

            <TabContent activeTab={"tabs" + tabs}>
              <TabPane tabId="tabs0">
                <Container fluid>
                  <div className="text-center m-4">
                    <h2 class="ml-2"> ¿Qué puedes hacer en pagos? </h2>
                  </div>
                  <Row className="mt-5 ml-7 mr-7">
                    <Col xl="4" lg="4">
                      <div class="feature ng-star-inserted">
                        <div class="icon">
                          <span class="icon icon-usuario">
                            <i class="fas fa-user"></i>
                          </span>
                        </div>
                        <div class="description">
                          <p ><span class="avv-title-semibold">Pagos internos </span>desde tus cuentas de ahorros o corrientes con las que cuentes a tus préstamos.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col xl="4" lg="4">
                      <div class="feature ng-star-inserted">
                        <div class="icon">
                          <span class="icon icon-usuario">
                            <i class="fas fa-exchange-alt"></i>
                          </span>
                        </div>
                        <div class="description">
                          <p ><span class="avv-title-semibold">Pago pse</span>  a tus préstamos desde la modalidad de Pago seguro en línea, desde una cuenta de otro banco.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col xl="4" lg="4">
                      <div class="feature ng-star-inserted">
                        <div class="icon">
                          <span class="icon icon-usuario">
                            <i class="fas fa-list-ol"></i>
                          </span>
                        </div>
                        <div class="description">
                          <p ><span class="avv-title-semibold">Consulta los pagos realizados</span>  y descarga los comprobantes.
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs1" className="">
                <Container fluid>
                  <Row>
                    <Col xl="3" lg="2"></Col>

                    <Col xl="6" lg="8">
                      <DivStepper step={step} listStep={listStep} tab={1}>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Elige el crédito a pagar </h2>
                          </div>
                          <Loans data={loans} tab={1}></Loans>
                        </DivStep>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Ingrese el valor a cancelar </h2>
                          </div>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mt-2 mb-2">
                            <div className="inputs-icons-borderbott">
                              <Input
                                className="form-control h5 p-1"
                                placeholder="Valor a transferir"
                                type="text"
                                key={value}
                                autoComplete="new-value"
                                onChange={valueChange}
                                value={value}
                                autoFocus
                                style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}}
                                 />
                                 <i className="fas fa-dollar-sign" />
                            </div>
                              <InputGroupAddon addonType="append">
                              </InputGroupAddon>
                            </InputGroup>
                          </FormGroup>
                          <div className="mt-3">
                            <button style={{width:"50%"}}disabled={!value} onClick={() => getRelatedAccounts()} block size="lg" className="my-btn bg-green text-white btn shadow btn-rounded btn-lg btn-block ml-auto mr-auto">
                              Continuar
                            </button>
                          </div>
                        </DivStep>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Elige la cuenta con la que pagará </h2>
                          </div>
                          <Accounts data={accounts} tab={1}></Accounts>
                        </DivStep>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Vas a cancelar </h2>
                          </div>
                          <div className="card p-4 m-4 shadow" style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                            <ul className style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Valor</p>
                                <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={value} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Costo</p>
                                <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={commission} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Hacia</p>
                                <div style={{ textAlign: "right", margin: 0 }}>
                                  <p style={{ margin: 0 }}>{productTwo.ownerAccount}</p>
                                  <p style={{ margin: 0 }}>Santander</p>
                                  <p style={{ margin: 0 }}> Prestamo No. {productTwo.accountNumber}</p>
                                </div>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Desde</p>
                                <div style={{ textAlign: "right", margin: 0 }}>
                                  <p style={{ margin: 0 }}>Ahorros No. {productOne.accountNumber}</p>
                                  <p style={{ margin: 0 }}>Disponible <NumberFormat value={productOne.balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <button style={{width:"50%"}} onClick={() => this.toggleModal("notificationModal")} block size="lg" className="my-btn bg-green text-white btn shadow btn-rounded btn-block btn-lg mt-5 ml-auto mr-auto">
                            Pagar
                          </button>
                        </DivStep>
                      </DivStepper>
                    </Col>
                    <Col xl="3" lg="2"></Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs2" className="">
                <Container fluid>
                  <Row>
                    <Col xl="3" lg="2"></Col>

                    <Col xl="6" lg="8">
                      <DivStepper step={stepPse} listStep={listStepPse} tab={2}>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Elige el crédito a pagar </h2>
                          </div>
                          <Loans data={loans} tab={2}></Loans>
                        </DivStep>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Ingrese el valor a cancelar </h2>
                          </div>
                          <FormGroup>
                            <InputGroup className="input-group-alternative mb-4">
                              <Input
                                placeholder="Valor a transferir"
                                type="text"
                                key={value}
                                autoComplete="new-value"
                                onChange={valueChange}
                                value={value}
                                autoFocus />
                              <InputGroupAddon addonType="append">
                                <InputGroupText>
                                  <i className="fas fa-dollar-sign" />
                                </InputGroupText>
                              </InputGroupAddon>
                            </InputGroup>
                          </FormGroup>
                          <div className="mt-3">
                            <button disabled={!value} onClick={() => getPseBanks()} block size="lg" className="my-btn bg-green text-white btn shadow btn-rounded btn-lg btn-block">
                              Continuar
                            </button>
                          </div>
                        </DivStep>
                        <DivStep>
                          <div>
                            <h2 class="text-center m-4"> Llena el formulario PSE </h2>
                            <div className="bg-gradient-primary text-white p-4 shadow m-4" style={{ borderRadius: 0.5 + "rem" }}>
                              <Row>
                                <Col lg="2">1.</Col>
                                <Col lg="8">Todas las compras y pagos por PSE son realizados en línea y
                                  la confirmación es inmedidata.</Col>
                              </Row>
                              <Row className="mt-2">
                                <Col lg="2">2.</Col>
                                <Col>Algunos bancos tienen un procedimineto de autenticación en su página (por ejemplo,
                                  una segunda clave), si nunca has realizado pagos por internet con tu cuenta de ahorros
                                  o corriente, es posible que necesites tramitar una autorización ante tu banco.</Col>
                              </Row>
                            </div>
                            <FormGroup>
                              <PseBanks></PseBanks>
                              <InputGroup className="input-group-alternative mb-4">
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText>
                                    <i className="fas fa-id-card" />
                                  </InputGroupText>
                                </InputGroupAddon>
                                <Input
                                  placeholder="Nombre del Titular"
                                  type="text"
                                  key={value}
                                  autoComplete="new-value"
                                  onChange={valueChange}
                                  value={value}
                                  autoFocus />
                              </InputGroup>
                              <InputGroup className="input-group-alternative mb-4">
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText>
                                    <i className="fas fa-user-friends" />
                                  </InputGroupText>
                                </InputGroupAddon>
                                <select class="selectpicker" placeholder="Tipo de Docuemnto" className="form-control input-group-alternative">
                                  <option value="1">Persona Natural</option>
                                  <option value="2">Tarjeta de Identidad</option>
                                  <option value="3">Cédula de Extranjería</option>
                                </select>
                              </InputGroup>
                              <InputGroup className="input-group-alternative mb-4">
                                <InputGroupAddon addonType="prepend">
                                  <InputGroupText>
                                    <i className="far fa-list-alt" />
                                  </InputGroupText>
                                </InputGroupAddon>
                                <select class="selectpicker" placeholder="Tipo de Docuemnto" className="form-control input-group-alternative">
                                  <option value="1">C.C (Cédula de ciudadanía)</option>
                                  <option value="2">Tarjeta de Identidad</option>
                                  <option value="3">Cédula de Extranjería</option>
                                </select>
                              </InputGroup>
                              <Row>
                                <Col>
                                  <InputGroup className="input-group-alternative">
                                    <InputGroupAddon addonType="prepend">
                                      <InputGroupText>
                                        <i className="far fa-list-alt" />
                                      </InputGroupText>
                                    </InputGroupAddon>
                                    <select class="selectpicker" placeholder="Tipo de Docuemnto" className="form-control input-group-alternative">
                                      <option value="1">+57 Colombia</option>
                                      <option value="2">Tarjeta de Identidad</option>
                                      <option value="3">Cédula de Extranjería</option>
                                    </select>
                                  </InputGroup>
                                </Col>
                                <Col>
                                  <InputGroup className="input-group-alternative">
                                    <Input
                                      placeholder="Telefono"
                                      type="text"
                                      key={value}
                                      autoComplete="new-value"
                                      onChange={valueChange}
                                      value={value}
                                      autoFocus />
                                    <InputGroupAddon addonType="append">
                                      <InputGroupText>
                                        <i className="fas fa-dollar-sign" />
                                      </InputGroupText>
                                    </InputGroupAddon>
                                  </InputGroup>
                                </Col>
                              </Row>

                            </FormGroup>
                            <div className="mt-3 mb-3">
                              <button onClick={() => { this.toggleModal("notificationModal"); getCommission(5) }} block size="lg" className="my-btn bg-gradient-primary text-white btn shadow btn-rounded btn-lg btn-block">
                                Pagar
                              </button>
                            </div>
                          </div>
                        </DivStep>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Vas a cancelar </h2>
                          </div>
                          <div className="card p-4" style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                            <ul className style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Valor</p>
                                <p style={{ textAlign: "right", margin: 0 }}>10000</p>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Costo</p>
                                <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={commission} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Hacia</p>
                                <div style={{ textAlign: "right", margin: 0 }}>
                                  <p style={{ margin: 0 }}> Préstamo No. 702766010 </p>
                                </div>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Desde</p>
                                <div style={{ textAlign: "right", margin: 0 }}>
                                  <p style={{ margin: 0 }}>Ahorros No. 702766010</p>
                                  <p style={{ margin: 0 }}>Disponible $15.792.276</p>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <Button onClick={() => this.toggleModal("notificationModal")} block size="lg" className="my-btn bg-gradient-primary text-white btn shadow btn-rounded">
                            Pagar
                          </Button>

                        </DivStep>
                      </DivStepper>
                    </Col>
                    <Col xl="3" lg="2"></Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs3">
                <div className="col-md-12">
                  <HistoricalTransfers data={historicalTransfer}></HistoricalTransfers>
                </div>
              </TabPane>
            </TabContent>
          </Container>
        </>

      );
    }
  }

  return (
    <NavsTransfer></NavsTransfer>
  )
}

export default PaysHeader;
